import { render, staticRenderFns } from "./launchReturn.vue?vue&type=template&id=2218590b"
import script from "./launchReturn.vue?vue&type=script&lang=js"
export * from "./launchReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports